import React from "react";
import {GetCurrentLocale} from "./Utils";
import t,{changeLanguage} from "./I18N/TranslateHelpers";
import {useSelector} from "react-redux";
import {RootState} from "../app/RootReducer";

interface ComponentProps {
  showToaster: boolean,
  setShowToaster: any,
  isToasterForCart: boolean,
  setIsToasterForCart: any
}

const Toaster: React.FC<ComponentProps> = ({showToaster, setShowToaster, isToasterForCart, setIsToasterForCart}: ComponentProps) => {
  const locale = GetCurrentLocale();
  changeLanguage(locale)

  const itemsInCart = useSelector((state: RootState) => state.cartRdc.cart )

  const closeToasterModal = () => {
    setShowToaster(false)
    setIsToasterForCart(false)
  }
  return (
    <div style={{position: "fixed", top: "20px", right: "20px"}}>
      <div role="alert" aria-live="assertive" aria-atomic="true" className={ showToaster ? "toast fade show" : "toast"} data-bs-autohide="false">
        <div className="toast-header">
          <svg width="20" height="20" className="mr-2" viewBox="0 0 24 24">
            <path
              d="M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M11,16.5L18,9.5L16.59,8.09L11,13.67L7.91,10.59L6.5,12L11,16.5Z"
              fill="#ccc"></path>
          </svg>
          <strong className="mr-auto">
            {
              !isToasterForCart ?
                t('request_an_offer')
                :
                t('your_cart')
            }
          </strong>
          <button type="button" className="ml-2 mb-1 close" data-dismiss="toast" aria-label="Close" onClick={closeToasterModal}>
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="toast-body">
                <span>
                    { t('product_added') }
                </span>
          {
            itemsInCart && itemsInCart.items.length < 1  ?
              <a href={ "/" + locale + t('url_request_offer')}>
                { t('show')}
              </a>
              :
              <a href={ "/" + locale + t('url_cart')}>
                { t('show')}
              </a>
          }
        </div>
      </div>
    </div>
  )
}

export default Toaster;
